import { render, staticRenderFns } from "./FCellOutOfTotal.vue?vue&type=template&id=50e5700b&"
import script from "./FCellOutOfTotal.vue?vue&type=script&lang=ts&"
export * from "./FCellOutOfTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports